import React, { Component } from 'react';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import URLSearchParams from 'url-search-params'
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl'
import "../assets/vendors/style"
import indigoTheme from './themes/indigoTheme';
import cyanTheme from './themes/cyanTheme';
import orangeTheme from './themes/orangeTheme';
import amberTheme from './themes/amberTheme';
import pinkTheme from './themes/pinkTheme';
import blueTheme from './themes/blueTheme';
import purpleTheme from './themes/purpleTheme';
import greenTheme from './themes/greenTheme';
import darkTheme from './themes/darkTheme';
import AppLocale from '../lngProvider';
import {
  AMBER,
  BLUE,
  CYAN,
  DARK_AMBER,
  DARK_BLUE,
  DARK_CYAN,
  DARK_DEEP_ORANGE,
  DARK_DEEP_PURPLE,
  DARK_GREEN,
  DARK_PINK,
  DEEP_ORANGE,
  DEEP_PURPLE,
  GREEN,
  INDIGO,
  PINK
} from 'constants/ThemeColors';

import {
  DARK_INDIGO
} from '../constants/ThemeColors';

import { setInitUrl } from '../actions/Auth';
import RTL from 'util/RTL';
import asyncComponent from 'util/asyncComponent';
import { setDarkTheme, setThemeColor } from "../actions/Setting";
import Backdrop from 'codeArt/components/Backdrop';
import { Confirm, Alert, SweetConfirm, SweetAlert, Snackbar } from 'codeArt/components/Modal';
import { Downloader, download } from 'codeArt/components/Explorer';
import { NotificationContainer } from 'react-notifications';
import { Util } from 'codeArt/common';
import { WorkProgress } from 'codeArt/components/Progress';
import { Principal } from 'codeArt/auth';

function alreadyUnauth(props){
  return props.location.pathname === getConfig("rewrite.unauth");
}

export const RestrictedRoute = ({ component: Component, ...rest }) =>
  <Route
    {...rest}
    render={props =>
      Principal.current() || alreadyUnauth(props)
        ? <Component {...props} />
        : <Redirect
          to={{
            pathname: getConfig("rewrite.unauth"),
            state: { from: props.location }
          }}
        />}
  />;

let config = null;

export function getConfig(path,defaultValue){
  if(!config) return defaultValue;
  let value = null;
  try{
    eval(`value=config.${path};`);
  }
  catch{ 
    value = defaultValue;
  }
  if(Util.empty(value)) return defaultValue;
  return Util.empty(value)?defaultValue : value;
}


class _Apps extends Component {

  constructor(props) {
    super(props);
    config = props.config;
  }

  componentWillMount() {
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
    if (this.props.initURL === '') {
      this.props.setInitUrl(this.props.history.location.pathname);
    }
    const params = new URLSearchParams(this.props.location.search);
    if (params.has("theme-name")) {
      this.props.setThemeColor(params.get('theme-name'));
    }
    if (params.has("dark-theme")) {
      this.props.setDarkTheme();
    }

    window.download = download;
  }

  getColorTheme(themeColor, applyTheme) {
    switch (themeColor) {
      case INDIGO: {
        applyTheme = createMuiTheme(indigoTheme);
        break;
      }
      case CYAN: {
        applyTheme = createMuiTheme(cyanTheme);
        break;
      }
      case AMBER: {
        applyTheme = createMuiTheme(amberTheme);
        break;
      }
      case DEEP_ORANGE: {
        applyTheme = createMuiTheme(orangeTheme);
        break;
      }
      case PINK: {
        applyTheme = createMuiTheme(pinkTheme);
        break;
      }
      case BLUE: {
        applyTheme = createMuiTheme(blueTheme);
        break;
      }
      case DEEP_PURPLE: {
        applyTheme = createMuiTheme(purpleTheme);
        break;
      }
      case GREEN: {
        applyTheme = createMuiTheme(greenTheme);
        break;
      }
      case DARK_INDIGO: {
        applyTheme = createMuiTheme(indigoTheme);
        break;
      }
      case DARK_CYAN: {
        applyTheme = createMuiTheme(cyanTheme);
        break;
      }
      case DARK_AMBER: {
        applyTheme = createMuiTheme(amberTheme);
        break;
      }
      case DARK_DEEP_ORANGE: {
        applyTheme = createMuiTheme(orangeTheme);
        break;
      }
      case DARK_PINK: {
        applyTheme = createMuiTheme(pinkTheme);
        break;
      }
      case DARK_BLUE: {
        applyTheme = createMuiTheme(blueTheme);
        break;
      }
      case DARK_DEEP_PURPLE: {
        applyTheme = createMuiTheme(purpleTheme);
        break;
      }
      case DARK_GREEN: {
        applyTheme = createMuiTheme(greenTheme);
        break;
      }
      default: createMuiTheme(indigoTheme);
    }
    return applyTheme;
  }

  render() {
    const { match, location, isDarkTheme, locale, isDirectionRTL } = this.props;
    let { themeColor } = this.props;
    let applyTheme = createMuiTheme(indigoTheme);
    if (isDarkTheme) {
      document.body.classList.add('dark-theme');
      applyTheme = createMuiTheme(darkTheme)
    } else {
      applyTheme = this.getColorTheme(themeColor, applyTheme);
    }

    let authUser = Principal.current();
    if (location.pathname === '/') {
      window.location.href=authUser?getConfig("rewrite.auth"):getConfig("rewrite.unauth");
      return <p className="d-flex flex-column c-flex-1 justify-content-center align-items-center m-text-muted c-text-s6">加载中</p>;  //这里以后可以补上 页面跳转中的装饰内容
      // return authUser === null ? <Redirect to={getConfig("rewrite.unauth")} /> : <Redirect to={getConfig("rewrite.auth")} />;
    }
    if (isDirectionRTL) {
      applyTheme.direction = 'rtl';
      document.body.classList.add('rtl')
    } else {
      document.body.classList.remove('rtl');
      applyTheme.direction = 'ltr';
    }

    const currentAppLocale = AppLocale[locale.locale];
    return (
      <ThemeProvider theme={applyTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}>
            <RTL>
              <div className="app-main">
                {this.props.children}
                <Backdrop />
                <WorkProgress />
                <Confirm />
                <Alert />
                <Snackbar />
                <SweetConfirm />
                <SweetAlert />
                <NotificationContainer />
                <Downloader />
              </div>
            </RTL>
          </IntlProvider>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { themeColor, sideNavColor, darkTheme, locale, isDirectionRTL } = settings;
  return { themeColor, sideNavColor, isDarkTheme: darkTheme, locale, isDirectionRTL }
};

const Apps = connect(mapStateToProps, { setInitUrl, setThemeColor, setDarkTheme })(_Apps);
export default Apps;